import { useLocation } from "react-router-dom";
import { DEFAULT_LOCALE, getLocaleFromPath, type Locale } from "@/i18n/types";

/**
 * Returns the current active locale based on the URL path.
 * Falls back to the default locale (es) when no prefix is present.
 */
export function useLocale(): Locale {
  const { pathname } = useLocation();
  return getLocaleFromPath(pathname) ?? DEFAULT_LOCALE;
}
